import { FETCH_COLUMN_ONE } from "../actions/types";

const initialState = {
  details: {},
  detail: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_COLUMN_ONE:
      return {
        ...state,
        details: action.payload
      };
    default:
      return state;
  }
}
